import angular from 'angular';

const KEYS = {
    ANCILLARIES: 'ANCILLARIES'
};

const SUBKEYS = {
    CO2_FOOTPRINT: 'CO2_FOOTPRINT'
};

const VALUES = {
    MODULE_OPEN: 'moduleOpen',
    MODAL_ACTIVE_TOGGLE: 'modalActiveToggle',
    MODAL_ACCEPT_ADD: 'modalAcceptAdd',
    MODAL_ACCEPT_REMOVE: 'modalAcceptRemove'
};

export const DatalayerUniqueConstants = {
    KEYS,
    SUBKEYS,
    VALUES
};

